<template>
  <svg width="753" height="119" viewBox="0 0 753 119" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.0848 117.491H450.875C462.5 117.491 471.96 108.816 471.96 98.1574C471.96 87.4987 462.5 78.824 450.875 78.824H414.04C402.416 78.824 392.955 70.1494 392.955 59.4907C392.955 48.832 402.416 40.1574 414.04 40.1574H730.915C742.539 40.1574 752 31.4828 752 20.824C752 10.1653 742.539 1.49071 730.915 1.49071H101.241C89.6164 1.49071 80.1559 10.1653 80.1559 20.824C80.1559 31.4828 89.6164 40.1574 101.241 40.1574H306.955C318.58 40.1574 328.04 48.832 328.04 59.4907C328.04 70.1494 318.58 78.824 306.955 78.824H22.0848C10.4605 78.824 1 87.4987 1 98.1574C1 108.816 10.4605 117.491 22.0848 117.491Z" fill="white" stroke="#DBE4FF" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>

<style lang="scss" scoped>
 svg {
   fill: #fff;
   stroke-width: 2px;
   stroke: #dbe4ff;
 }
</style>
